import { Container1, Container2, Container3, Container4 } from '@/components/Containers'
import { LinkVideo, Video } from '@/components/Video'
import Layout from '@/components/Layout'
import Head from 'next/head'
import Loader from '@/components/Loader'

const purpose = () => {
  return (
    <>
    <Head>
    <title>Athena Mercury | Purpose</title>
        <meta name='description' content='OUR MOTIVATION - Our purpose lies in shining a spotlight on what defines womanhood within our society, and how we can go about empowering ourselves, how we can successfully rise from the ashes as self-assured individuals with agency of our own. Helping each other through the trials and tribulations they face by just existing.'/>
        <meta property="twitter:image" content="../public/icon.png" />
        <meta property="og:image" content="../public/icon.png" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:description" content="OUR MOTIVATION - Our purpose lies in shining a spotlight on what defines womanhood within our society, and how we can go about empowering ourselves, how we can successfully rise from the ashes as self-assured individuals with agency of our own. Helping each other through the trials and tribulations they face by just existing." />
        <meta property="og:description" content="OUR MOTIVATION - Our purpose lies in shining a spotlight on what defines womanhood within our society, and how we can go about empowering ourselves, how we can successfully rise from the ashes as self-assured individuals with agency of our own. Helping each other through the trials and tribulations they face by just existing." />
        <meta property="twitter:title" content="Athena Mercury | Purpose" />
        <meta property="og:title" content="Athena Mercury | Purpose" />
        <meta property="og:url" content="https://athenamercury.com/purpose" />
    </Head>
    <Loader />
    <main>
      <Layout className='space-y-10 desktop:space-y-16'>
      <div className='p-2 space-y-8'>
        <div className="space-y-6 flex flex-col items-center justify-center">
          <p className='para-headers font-bold'>OUR MOTIVATION</p>
          <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 mb-10 desktop:mb-16'/>
          <p className='para-text para-position font-text mb-10 desktop:mb-16'>Our purpose lies in shining a spotlight on what defines womanhood within our society, and how we can go about empowering ourselves, how we can successfully rise from the ashes as self-assured individuals with agency of our own. Helping each other through the trials and tribulations we as Women face by just existing.</p>
        </div>
        <Video 
        href="https://res.cloudinary.com/dxrtssxet/video/upload/v1678965029/Athena%20Mercury/Athena%20Mercury%20-%20Purpose/RESEARCH_avxhco.mp4"
        />
        <div className="space-y-6 flex flex-col items-center justify-center">
          <p className='para-headers font-bold'>WE&apos;RE NOT OKAY</p>
          <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 mb-10 desktop:mb-16'/>
          <p className='para-text para-position font-text'>There&apos;s such a broad spectrum of arbitrary scenarios women deal with. This has us asking these questions:</p>
        </div>
      </div>
      <div className="flex flex-wrap justify-center text-center font-header para-purpose font-bold px-10 tablet:px-24 tablet:space-y-6">
        <div className="w-full tablet:pt-8 laptop:w-1/3 p-2 space-y-5">
          <p className=''>How much progress woman have truthfully made over the past 100 years?</p>
        </div>
        <hr className='block laptop:hidden mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
        <div className="w-full laptop:w-1/3 p-2 space-y-5">
          <p className=''>We may have made a lot of progress as Women, for example, gaining the vote, me too movement, women in politics. But how much progress have we really made?</p>
        </div>
        <hr className='block laptop:hidden mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
        <div className="w-full laptop:w-1/3 p-2 space-y-5">
          <p className=''>Do women own the rights to their minds, subconscious and bodies or does society?</p>
        </div>
      </div>
      <div className='w-full p-2 space-y-8 flex flex-col items-center justify-center para-position'>
        <p className='para-headers font-bold'>DIRECT DONATIONS</p>
        <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 mb-10 desktop:mb-16'/>
        <p className='para-text font-text'><strong>10% of all purchases are DIRECTLY DONATED TO AID THE CAUSE. 
          </strong>Through direct charity work we can actively work towards a <strong>better world for Woman. 
          </strong> With the help of <a href="https://www.actionaid.org.uk" target="_blank" className="hover:text-hover hover:no-underline font-bold underline">
          Action Aid</a>,<strong> we donate 5% of all purchases/commissions to women in need in third world countries. </strong> 
          This provides urgent help for issues including domestic abuse, child marriage and FGM. With the remaining 5% of all purchases 
          donated to <a href="https://refuge.org.uk" target="_blank" className="underline font-bold hover:text-hover hover:no-underline">REFUGE</a> - for women and 
          children against domestic violence. <strong>Helping vulnerable women</strong> within the UK, whilst championing 
          improvements in the safety and control women possess in their day to day lives.
        </p>
      </div>
      <div className='flex flex-col items-center justify-center w-full p-2 text-center'>
        <div className='space-y-8 para-position'>
          <p className='para-headers font-bold'>FULL TRANSPARENCY</p>
          <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 mb-10 desktop:mb-16'/>
          <p className='para-text font-text'>
            As a brand we aim to create a <strong>community of trusting women that can grow 
            together,</strong> we understand the importance of transparency when it comes to
            the percentage of contributions you give to help aid women&apos;s charities.
          </p>
          <p className='para-text font-text'>We aim to praise this generosity, so, with each 
            purchase you will receive <strong>evidence of your contribution to the cause. </strong> 
            Showing how much you donated to each charity, combined with empowering quotes.
          </p>
        </div>
      </div>
      <Video 
      href="https://res.cloudinary.com/dxrtssxet/video/upload/v1678965031/Athena%20Mercury/Athena%20Mercury%20-%20Purpose/PURPOSE_SECTION_fglri0.mp4"
      />
      <hr className='block laptop:hidden mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
      <div className="container mx-auto p-6 tablet:w-1/2 mobile:pb-0">
            <div className="flex-col flex items-stretch justify-center -mx-4">
              <Container1 />
              <Container2 />
            </div>
      </div>
      <div className="container mx-auto p-6 tablet:pb-36">
            <div className="flex flex-col tablet:flex-row items-center justify-center -mx-4">
              <Container3 />
              <Container4 />
            </div>
      </div>
      <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
      <div className='w-full p-2 space-y-8 text-center para-position'>
        <p className='para-headers font-bold'>JOIN THE CONVERSATION - ACTIVISM & CAMPAIGNING</p>
        <p className='para-headers font-bold'>THE MONTHLY MEETINGS: VOICING WOMEN&apos;S FEELINGS</p>
        <p className='para-text font-text'>We believe that real change comes when people gather and share their points of view. Join us at our monthly meetings. Details are posted <a href="https://www.instagram.com/athena_mercury_london/" target="_blank" className="hover:text-cmyk underline font-bold hover:no-underline">here</a>.</p>
      </div>
      <hr className='mx-auto my-6 bg-black h-0.5 w-1/2 mt-5 desktop:mb-10'/>
      <LinkVideo 
      href='https://res.cloudinary.com/dxrtssxet/video/upload/v1682176436/Athena%20Mercury/Athena%20Mercury%20-%20Videos/JUMPSUIT_NEW_SIZE_compressed_video_20230422_150926_cqisbz.mp4'
      link='/contact'
      title='contact'
      />
      </Layout>
    </main>

    </>
  )
}

export default purpose